import {Component, inject, OnInit, signal} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';

@Component({
  selector: 'notfound',
  imports: [],
  styles: `

    body{
      height: 100% !important;
    }
    .inner-section{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .notfound {
      width: 850px;
      max-width: 100%;
      margin: 0 auto;
      text-align: center;
      padding: 150px 10px 120px 10px;
      min-height: calc(100vh - 615px)
    }
    .button{
      white-space: nowrap;
    }
    .sub-title-margin{
        margin-bottom: 60px;
    }
  `,
  template: `
    <div class="inner-section">
      <div class="notfound">
        <h1>{{textTitle()}}</h1>
        <p class="din-pro-simple-text sub-title-margin">
          {{subTextTitle()}}
        </p>
        <button (click)="goToPortal()" class="button active">вернуться на главную</button>
      </div>
    </div>
`

})
export class Notfound implements OnInit{
  private router = inject(Router);
   public textTitle = signal<string | null>(null)
   public subTextTitle = signal<string | null>(null)

  ngOnInit(): void {
    const url = this.router.url;
    if (url.includes('not-found')) {
      this.textTitle.set('Страница не найдена')
      this.subTextTitle.set('Похоже страница, на которой вы находитесь, в разработке или была удалена. Приносим свои извинения.')
    } else if (url.includes('error-course')) {
      this.textTitle.set('Курс не найден')
      this.subTextTitle.set('Запрашиваемый курс недоступен. Возможно, он был удалён или ссылка указана некорректно.')
    }
  }

  public goToPortal(){
    window.location.replace(environment.portalOnfUrl);
  }
}
